import { get_project_info_localStorage } from "src/DAL/localStorage/localStorage";
import { update_root_value } from "src/utils/domUtils";

export const baseUri = process.env.REACT_APP_API_BASE_URL;
export const s3baseUrl = process.env.REACT_APP_PIC_BASE_URL;
export const socketUrl = process.env.REACT_APP_SOCKET_URL;
export const project_name = "BMS-gym";
export const websiteBaseUrl = process.env.REACT_APP_WEBSITE_BASE_URL;
export const api_key = process.env.REACT_APP_WEB_API_KEY;

const get_project_info = get_project_info_localStorage();
export const material_theme_palate = {
  lighter: "#04abbb",
  light: "#04abbb",
  main: "#04abbb",
  dark: " #04abbb",
  darker: " #04abbb",
  contrastText: "#fff",
};

export const OwnerName = () => {
  return "GymRite";
};

export const ownerName = "GymRite's";
export const ownerCompleteName = "GymRite";

export const get_app_logo = () => {
  if (get_project_info && get_project_info.brand_logo) {
    return s3baseUrl + get_project_info.brand_logo;
  } else {
    return "";
  }
};

export const get_app_headers = () => {
  if (get_project_info && get_project_info.meta_title) {
    return {
      title: get_project_info.meta_title,
      description: get_project_info.meta_description,
      fav_icon: s3baseUrl + get_project_info.brand_favicon,
    };
  } else {
    return {
      title: "GymRite | Client",
      description: "GymRite | Client",
      fav_icon: "",
    };
  }
};

material_theme_palate.main = " #04abbb";
material_theme_palate.main = " #04abbb";
/* Main theme color */
update_root_value("--portal-theme-primary", " #04abbb");
update_root_value("--portal-theme-secondary", "#04abbb17");
update_root_value("--text-primary-color", "black");
update_root_value("--text-secondary-color", "rgb(150, 150, 150)");
update_root_value("--text-color", "black");

/* Main background color*/
update_root_value("--background-primary-color", "#fff");
update_root_value("--background-secondary-color", "#fff");

/* Sidebar Properties */
update_root_value("--sidebars-text-color", "black");
update_root_value("--sidebars-active-color", "#C19D60");
update_root_value("--sidebars-hover-color:", "#C19D60");
update_root_value("--sidebars-background-color", "#ffffff");

/* Popup / Popover properties  */
update_root_value("--popup-background-color", "white");
update_root_value("--popup-text-color", " #04abbb");

/* Element properties */
update_root_value("--input-text-color", "black");
update_root_value("--input-placeholder-color", "#fff");
update_root_value("--input-background-primary", "#fff");
update_root_value("--input-background-secondary", "#1d1c1d");
update_root_value(" --icons-color-allover", "#C19D60");

/* Button Properties */

update_root_value("--button-background-color", " #04abbb");
update_root_value("--button-text-color", "#fff");
update_root_value("--button-outlined-color", " #04abbb");
update_root_value("--button-hover-color", " #04abbb");

/* Audio Properties */
update_root_value("--audio-color", "rgb(56, 54, 54)");

/* calendar Properties */
update_root_value("--calendar-selected-box", "#8b8b8b");
